import React from 'react';
export function ActivitySummaryTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-65">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-66">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-67" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-68">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-69">
          Your account activity summary
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-70">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-71">
          Here's a summary of recent sign-in activity on your Aisco Workspace
          account over the past 7 days.
        </p>

        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #2563eb',
        marginBottom: '32px'
      }} data-id="element-72">
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px'
        }} data-id="element-73">
            <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1e40af',
            margin: '0'
          }} data-id="element-74">
              Activity Overview
            </h3>
            <span style={{
            fontSize: '12px',
            color: '#1e40af',
            backgroundColor: '#dbeafe',
            padding: '4px 12px',
            borderRadius: '12px',
            fontWeight: '500'
          }} data-id="element-75">
              Last 7 days
            </span>
          </div>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-76">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-77">
              <span style={{
              color: '#1e40af'
            }} data-id="element-78">
                Total sign-ins:
              </span>
              <span style={{
              color: '#1e40af',
              fontWeight: '600'
            }} data-id="element-79">
                12
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-80">
              <span style={{
              color: '#1e40af'
            }} data-id="element-81">
                Unique devices:
              </span>
              <span style={{
              color: '#1e40af',
              fontWeight: '600'
            }} data-id="element-82">
                3
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-83">
              <span style={{
              color: '#1e40af'
            }} data-id="element-84">
                Locations:
              </span>
              <span style={{
              color: '#1e40af',
              fontWeight: '600'
            }} data-id="element-85">
                2
              </span>
            </div>
          </div>
        </div>

        <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#1f2937',
        marginTop: '32px',
        marginBottom: '16px'
      }} data-id="element-86">
          Recent Sign-ins
        </h3>

        {/* Sign-in 1 */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '12px'
      }} data-id="element-87">
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: '8px'
        }} data-id="element-88">
            <div data-id="element-89">
              <p style={{
              margin: '0 0 4px 0',
              fontSize: '14px',
              fontWeight: '600',
              color: '#1f2937'
            }} data-id="element-90">
                Chrome on macOS
              </p>
              <p style={{
              margin: '0',
              fontSize: '13px',
              color: '#6b7280'
            }} data-id="element-91">
                Madrid, Spain • 192.168.1.1
              </p>
            </div>
            <span style={{
            fontSize: '12px',
            color: '#10b981',
            backgroundColor: '#d1fae5',
            padding: '4px 8px',
            borderRadius: '4px',
            fontWeight: '500'
          }} data-id="element-92">
              Trusted
            </span>
          </div>
          <p style={{
          margin: '8px 0 0 0',
          fontSize: '12px',
          color: '#9ca3af'
        }} data-id="element-93">
            January 15, 2025 at 10:30 AM
          </p>
        </div>

        {/* Sign-in 2 */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '12px'
      }} data-id="element-94">
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: '8px'
        }} data-id="element-95">
            <div data-id="element-96">
              <p style={{
              margin: '0 0 4px 0',
              fontSize: '14px',
              fontWeight: '600',
              color: '#1f2937'
            }} data-id="element-97">
                Safari on iPhone
              </p>
              <p style={{
              margin: '0',
              fontSize: '13px',
              color: '#6b7280'
            }} data-id="element-98">
                Madrid, Spain • 192.168.1.25
              </p>
            </div>
            <span style={{
            fontSize: '12px',
            color: '#10b981',
            backgroundColor: '#d1fae5',
            padding: '4px 8px',
            borderRadius: '4px',
            fontWeight: '500'
          }} data-id="element-99">
              Trusted
            </span>
          </div>
          <p style={{
          margin: '8px 0 0 0',
          fontSize: '12px',
          color: '#9ca3af'
        }} data-id="element-100">
            January 14, 2025 at 3:45 PM
          </p>
        </div>

        {/* Sign-in 3 */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '32px'
      }} data-id="element-101">
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: '8px'
        }} data-id="element-102">
            <div data-id="element-103">
              <p style={{
              margin: '0 0 4px 0',
              fontSize: '14px',
              fontWeight: '600',
              color: '#1f2937'
            }} data-id="element-104">
                Firefox on Windows
              </p>
              <p style={{
              margin: '0',
              fontSize: '13px',
              color: '#6b7280'
            }} data-id="element-105">
                Barcelona, Spain • 192.168.2.10
              </p>
            </div>
            <span style={{
            fontSize: '12px',
            color: '#6b7280',
            backgroundColor: '#f3f4f6',
            padding: '4px 8px',
            borderRadius: '4px',
            fontWeight: '500'
          }} data-id="element-106">
              New
            </span>
          </div>
          <p style={{
          margin: '8px 0 0 0',
          fontSize: '12px',
          color: '#9ca3af'
        }} data-id="element-107">
            January 13, 2025 at 9:15 AM
          </p>
        </div>

        <div style={{
        backgroundColor: '#fef3c7',
        padding: '16px',
        borderRadius: '8px',
        borderLeft: '4px solid #f59e0b',
        marginBottom: '32px'
      }} data-id="element-108">
          <p style={{
          margin: '0',
          color: '#92400e',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-109">
            <strong data-id="element-110">Notice something unusual?</strong> If you don't recognize
            any of these sign-ins, secure your account immediately.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-111">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-112">
            View full activity log
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-113">
          You can manage your security settings and review all account activity
          anytime.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-114">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-115">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-116" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}